var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { Button, Modal } from 'antd';

/**
 *
 * props:
 *   buttonLabel
 *   className
 *   onClose
 *
 */

var DimioModal = function (_Component) {
  _inherits(DimioModal, _Component);

  function DimioModal(props) {
    _classCallCheck(this, DimioModal);

    var _this = _possibleConstructorReturn(this, (DimioModal.__proto__ || Object.getPrototypeOf(DimioModal)).call(this, props));

    _this.state = {
      visible: false
    };

    _this.onShow = _this.onShow.bind(_this);
    _this.onHide = _this.onHide.bind(_this);
    return _this;
  }

  _createClass(DimioModal, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.visible) {
        this.setState({ visible: nextProps.visible });
      }
    }
  }, {
    key: 'onShow',
    value: function onShow() {
      this.setState({ visible: true });
    }
  }, {
    key: 'onHide',
    value: function onHide() {
      this.setState({ visible: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          buttonLabel = _props.buttonLabel,
          buttonIcon = _props.buttonIcon,
          onClose = _props.onClose,
          className = _props.className;


      return React.createElement(
        'div',
        null,
        buttonLabel && React.createElement(
          Button,
          { onClick: this.onShow, icon: buttonIcon ? buttonIcon : null },
          buttonLabel
        ),
        React.createElement(
          Modal,
          {
            className: 'dimio-modal ' + (className ? className : '')
            //        {...this.props}
            , visible: this.state.visible,
            title: title ? title : null,
            onCancel: this.onHide,
            afterClose: this.props.onClose,
            footer: null
          },
          this.props.children
        )
      );
    }
  }]);

  return DimioModal;
}(Component);

export default DimioModal;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dimio/dist/DimioModal.js
// module id = 1332
// module chunks = 0